import About from "./About";
import Top from "./Top";
import { useEffect } from "react";
import Education from "./Education";
import Skills from "./Skills";
import ContactMe from "./ContactMe";
import Projects from "./Projects";

function App() {
  return (
    <div className="App">
      <Top />
      <About />
      <Education />
      <img src="2.gif" className="floatingimg"></img>
      <Skills />
      <Projects />
      <img src="3.gif" className="floatingimg"></img>
      <ContactMe />
      <img src="1.gif" className="bottomimg"></img>
    </div>
  );
}

export default App;
